<template>
    <div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">

                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">
                                        <div class="page-body">
                                            <h5 class="f-w-400 p-b-30">Offer Templates</h5>
                                            <a v-if="$checkPerm('offer_template.create')" href="/createoffertemplate"
                                                class="btn btn-sm btn-primary m-b-10"><i class="icofont icofont-plus"></i>Create
                                                Template</a>
                                            <div class="" style="">
                                                <input type="text" class="form-control" v-model="filter" placeholder="Search Templates...">
                                            </div>
                                            <div class="table-responsive">
                                                <datatable :columns="table_columns" :data="table_rows" :filter-by="filter"></datatable>
                                            </div>

                                            <div class="" style="text-align: center;">
                                                <datatable-pager v-model="page" type="long" :per-page="per_page"></datatable-pager>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-for="letter in table_rows" v-bind:id="'letter'+letter.id" class="modal fade" role="dialog">
            <div class="modal-dialog modal-lg">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{letter.template_name}}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task" v-html="letter.body">
                    </div>
                    <div class="modal-footer">
                        <a v-bind:href="'/editoffertemplate/' + letter.joblisting_id" class="btn btn-warning btn-md">Edit</a>
                        <button class="btn btn-primary btn-md" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import navbar1 from '../components/Navbar1.vue'
    import navbar2 from '../components/Navbar2.vue'

    export default {
        name: 'OfferTemplates',

        data() {
            return {
                page: 1,
                per_page: 10,
                filter: '',
                table_columns: [
                    { label: "Opening Name", field: 'name' },
                    { label: "Template Name", field: 'template_name' },
                    {
                        label: "Template Body", representedAs: (row) => {
                            return (row.body.length > 100) ? row.body.substring(0, 100) + "..." : row.body
                        }, interpolate: true
                    },
                    {
                        label: 'Action', representedAs: (row) => {
                            var s = '<button class="btn btn-sm btn-primary m-r-5" title="View" data-toggle="modal" data-target="#letter' + row.id + '"><i class="icofont icofont-eye"></i></button>'

                            if (this.$checkPerm('offer_template.create')) {
                                '<a href="/editoffertemplate/' + row.joblisting_id + '" class="btn btn-sm btn-warning" title="Edit this letter"><i class="icofont icofont-pencil"></i></a>'
                            }
                            return s
                        }, interpolate: true
                    }
                ],
                table_rows: []
            }
        },

        components: {
            navbar1,
            navbar2
        },

        mounted() {
            this.getOfferTemplates()
        },
        methods: {
            getOfferTemplates: function () {

                let resumes = {
                    what: 'GetOfferTemplate'
                }

                this.$socket.makeGetRequest(resumes)
                    .then((response) => {
                        if (response.type == "GetOfferTemplate") {
                            this.table_rows = response.data
                            console.log(response.data)
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        computed: {

        }
    }
</script>